import React, { useState, useEffect, useRef } from "react";
import { Steps, Spin } from "antd";
import PropTypes from "prop-types";
import { getRequest } from "../../axios";

const VendorDotStatus = ({
  prNumber,
  VendorID,
  prID,
  setDotLoaded,
  record,
}) => {
  const [currentStep, setCurrentStep] = useState(0); // Track the current step
  const [res, setRes] = useState([]);
  const [loading, setLoading] = useState(false); // Loading state
  const scrollContainerRef = useRef(null);
  useEffect(() => {
    console.log("PRIDDDDDD", prID);
    const getPurchaseRequisitionList = async () => {
      setLoading(true); // Start loading
      try {
        const apiResponse = await getRequest(
          `bid-rfq-po-stage/?vendor_id=${VendorID}&float_rfq_id=${prID}`
        );

        let fetchedData = [];
        if (record.bid_rfq_by_vendor !== false) {
          if (apiResponse.data.results.success) {
            fetchedData =
              apiResponse.data.results.data[0]?.stage_response || [];
          }
        } else {
          if (apiResponse.data.success) {
            fetchedData = apiResponse.data.data || [];
          }
        }

        setRes(fetchedData);
        setDotLoaded(true);

        // Find the index of the last 'Finished' step
        // Find last finished index
        const lastFinishedIndex = fetchedData
          .map((item) => item.title)
          .lastIndexOf("Finished");
        setCurrentStep(lastFinishedIndex === 0 ? lastFinishedIndex : 0);

        // Scroll to last finished step on hover
        setTimeout(() => {
          if (scrollContainerRef.current) {
            const stepElements =
              scrollContainerRef.current.querySelectorAll(".ant-steps-item");
            if (stepElements[lastFinishedIndex]) {
              stepElements[lastFinishedIndex].scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }
          }
        }, 200);
        // Find the next 'Waiting' step after the last 'Finished' step
        const nextWaitingIndex = fetchedData
          .slice(lastFinishedIndex + 1)
          .findIndex((item) => item.title === "Waiting");

        // If a 'Waiting' step exists, set the current step to it
        if (nextWaitingIndex !== -1) {
          setCurrentStep(lastFinishedIndex + 1 + nextWaitingIndex);
        } else {
          setCurrentStep(lastFinishedIndex); // If no 'Waiting' step, stay at the last 'Finished'
        }
      } catch (error) {
        console.error("Error fetching progress data:", error);
      } finally {
        setLoading(false); // Stop loading
      }
    };

    getPurchaseRequisitionList();
  }, [prID, VendorID, prNumber, record, setDotLoaded]);

  // Custom function to get step status
  // const getStepStatus = (item, index) => {
  //   if (item.title === "Finished") {
  //     return "finish"; // Mark as finished step
  //   }
  //   if (item.title === "Waiting") {
  //     return index === currentStep ? "process" : "wait"; // Only highlight next 'Waiting' step
  //   }
  //   return index < currentStep ? "finish" : "wait"; // Past steps are finished, others are in wait
  // };

  return (
    <div
      ref={scrollContainerRef}
      className="gridtimelinepopup"
      style={{ maxHeight: "400px", overflowY: "auto", padding: "10px" }}
    >
      {loading ? (
        <Spin
          tip="Loading..."
          style={{ display: "block", margin: "20px auto" }}
        />
      ) : (
        <Steps
          progressDot
          current={currentStep}
          direction="vertical"
          items={res.map((item, index) => ({
            title: (
              <span
                style={{
                  fontWeight: index === currentStep + 0 ? "650" : "normal", // Extra bold
                  fontSize: index === currentStep + 0 ? "16px" : "14px", // Slightly bigger
                  color: index === currentStep + 0 ? "#555555" : "inherit", // Highlighted red
                }}
              >
                {item.title}
              </span>
            ),
            description: (
              <span
                style={{
                  fontWeight: index === currentStep + 0 ? "650" : "normal",
                  fontSize: index === currentStep + 0 ? "16px" : "14px",
                  color: index === currentStep + 0 ? "#555555" : "inherit",
                }}
              >
                {item.title === "In Progress" ? (
                  <h6>{item.description}</h6>
                ) : (
                  item.description
                )}
              </span>
            ),

            // status: getStepStatus(item, index), // Assign custom status to each step
          }))}
        />
      )}
    </div>
  );
};

VendorDotStatus.propTypes = {
  prNumber: PropTypes.string,
  VendorID: PropTypes.number,
  prID: PropTypes.number,
  setDotLoaded: PropTypes.func,
  record: PropTypes.object,
};

export default React.memo(VendorDotStatus);
